import { useState } from "react";

import { useI18n } from "@/lib/i18n";

export default function UseCases() {
  const { locale, tx } = useI18n();
  const [showSummary, setShowSummary] = useState(false);
  const toggleComparison = () => setShowSummary((current) => !current);
  const transcription = locale === "en"
    ? "Transcript: Hi love, there’s a lot of traffic this afternoon its crazy. I’ll have to meet you at home. Oh yes, I um, still need to pick up Charlie from school. He has cricket today. I’ll be on my way after that. I wasn’t really sure what to do about dinner. I know you’re busy and I don’t really feel like cooking so I was thinking we could order pizza. Yeah I"
    : tx("Transcript: Hi love, there's a lot of traffic this afternoon its crazy. I'll have to meet you at home. Oh yes, I um, still need to pick up Charlie from school. He has cricket today. I'll be on my way after that. I wasn't really sure what to do about dinner. I know you're busy and I don't really feel like cooking so I was thinking we could order pizza. Yeah I...");
  const summary = locale === "en"
    ? "Summary: Rachel said she will meet you at home after she’s picked up Charlie from school. Pizza for dinner."
    : tx("Summary: Rachel said she will meet you at home after she's picked up Charlie from school. Pizza for dinner.");
  const transcriptEnding = locale === "en" ? transcription.slice(-"we could order pizza. Yeah I".length) : "";
  const transcriptFlowTail = locale === "en" ? "like cooking so I was thinking" : "";
  const transcriptFlowTailIndex = locale === "en"
    ? transcription.lastIndexOf(transcriptFlowTail)
    : -1;
  const transcriptLeadingCopy = locale === "en"
    ? transcription.slice(0, transcriptFlowTailIndex).trimEnd()
    : transcription;

  return (
    <section
      className="landing-comparison"
      data-view={showSummary ? "summary" : "transcript"}
      aria-labelledby="landing-comparison-title"
    >
      <h2 id="landing-comparison-title" className="sr-only">
        {tx("Compare a normal transcription with a Min summary")}
      </h2>
      <img
        className="landing-comparison__brand-mark landing-comparison__brand-mark--static"
        src="/landing/min-mark.png"
        alt=""
        aria-hidden="true"
      />
      <button
        type="button"
        className="landing-comparison__brand-mark landing-comparison__brand-trigger"
        aria-label={showSummary ? tx("Normal Transcription") : tx("Min Summary")}
        title={showSummary ? tx("Normal Transcription") : tx("Min Summary")}
        onClick={toggleComparison}
      >
        <img src="/landing/min-mark.png" alt="" aria-hidden="true" />
      </button>
      <div className="landing-comparison__frame">
        <img
          className="landing-comparison__background"
          src="/landing/info-background.jpg"
          alt={tx("A woman listening to a WhatsApp voice note while working at a table")}
          width="2400"
          height="1350"
          loading="lazy"
        />
        <div className="landing-comparison__content">
          <article
            className="landing-comparison__panel landing-comparison__panel--transcript"
            aria-hidden={showSummary}
          >
            <h3>
              <button
                type="button"
                className="landing-comparison__view-toggle"
                tabIndex={showSummary ? -1 : 0}
                onClick={toggleComparison}
              >
                {tx("Normal Transcription")}
              </button>
            </h3>
            <p className="landing-comparison__transcript-card">
              {locale === "en" ? (
                <>
                  {transcriptLeadingCopy}{" "}
                  <span className="landing-comparison__flow-tail">{transcriptFlowTail}</span>{" "}
                  <span className="landing-comparison__ending">{transcriptEnding}</span>
                </>
              ) : transcription}
              <i className="landing-comparison__scan" aria-hidden="true" />
            </p>
          </article>
        </div>
      </div>
      <article
        className="landing-comparison__panel landing-comparison__panel--summary"
        aria-hidden={!showSummary}
      >
        <h3>
          <button
            type="button"
            className="landing-comparison__view-toggle"
            tabIndex={showSummary ? 0 : -1}
            onClick={toggleComparison}
          >
            {tx("Min Summary")}
          </button>
        </h3>
        <div className="landing-comparison__summary-card" aria-live="polite">
          <img src="/landing/min-mark.png" alt="" aria-hidden="true" />
          <p>{summary}</p>
        </div>
      </article>
    </section>
  );
}
